<section class="comp-section">
  <h2>Projects</h2>
  <p>An overview of my Projects (private / as employee / as freelancer).</p>
  <a routerLink="/projects">Projects</a>
</section>
<div class="comp-between-section"></div>
